import React, { useState } from "react";

export default function FormContactComponents() {
  // state
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  });

  // function
  const handleOrderClick = () => {
    const message = `Halo Bale's!%0APerkenalkan saya ${
      formData.firstName + " " + formData.lastName
    } .%0AEmail : ${formData.email}%0APesan: %0A${formData.message}`;
    const url = `https://wa.me/6281216593329?text=${message}`;
    window.open(url, "_blank");
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  return (
    <div className="form">
      <div className="row">
        <div className="col-6">
          <input
            className="input-bale form-control form-control-lg"
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
          />
        </div>
        <div className="col-6">
          <input
            className="input-bale form-control form-control-lg"
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
          />
        </div>
        <div className="col-12">
          <input
            className="input-bale form-control form-control-lg"
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
          />
        </div>
        <div className="col-12">
          <textarea
            className="input-bale form-control form-control-lg"
            placeholder="Messages"
            name="message"
            rows={5}
            value={formData.message}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-12">
          <button
            onClick={handleOrderClick}
            className="btn btn-detail w-100 rounded-0 mt-2"
          >
            Kirim Pesan!
          </button>
        </div>
      </div>
    </div>
  );
}
